import map from 'lodash/map'
import { ProjectStatus } from '@ztechapps/project.common'
import type { ListFieldConfig } from '@ztechapps/common.hook'
import { ListFieldTypeEnum } from '@ztechapps/common.hook'

const Statuses = map(ProjectStatus, (e) => {
  return e.value
})

export const projectListFieldConfig: ListFieldConfig = {
  code: { name: 'code', index: 0, size: 150 },
  status: {
    name: 'status',
    excludeOnSearch: true,
    type: ListFieldTypeEnum.select,
    fieldSettings: {
      listValues: Statuses,
    },
    index: 1,
    size: 150,
  },
  name: { name: 'name', displayName: 'Project Name', index: 2, size: 300 },

  createdAt: {
    name: 'createdAt',
    displayName: 'Created At',
    type: ListFieldTypeEnum.dateTimeZone,
    excludeOnSearch: true,
    index: 3,
    size: 150,
  },

  completionDate: {
    name: 'completionDate',
    displayName: 'Completion Date',
    excludeOnSearch: true,
    type: ListFieldTypeEnum.dateTimeZone,
    index: 4,
    size: 150,
  },

  timeSpent: { name: 'timeSpent', index: 5, size: 200, excludeOnSearch: true },

  remarks: { name: 'remarks', index: 6, size: 400 },

  tags: { name: 'tags', isVisible: false },
  _id: { name: '_id', isVisible: false },
}
